// METIS Hub wording — namespace "common" (ko), 893 keys.
// Extracted once from the approved mockup (poc-plan/mockup-src: js/i18n.js + js/core.js + js/charts.js).
// From now on this file is the source: edit it by hand (keep ko/en keys in pairs — packages/i18n tests check
// key parity, Hangul in English text and the plan 9.1.3 wording rules). Placeholders: {name}, plural {n|one|other}.
const common: Record<string, string> = {
  "app.name": "METIS Hub",
  "app.tagline": "회사 AI 사용 기록소",
  "app.skip": "본문으로 건너뛰기",
  "app.docTitle": "{page} · METIS Hub",
  "nav.main": "주 메뉴",
  "nav.bottom": "하단 메뉴",
  "nav.home": "홈",
  "nav.logs": "사용 기록",
  "nav.stats": "통계",
  "nav.people": "사람·팀",
  "nav.connect": "도구 연결",
  "nav.glossary": "용어집",
  "nav.settings": "내 기록·동의",
  "nav.admin": "관리",
  "nav.admin.roles": "역할·권한",
  "nav.admin.policy": "기록 정책",
  "nav.admin.audit": "열람·변경 이력",
  "nav.admin.system": "수집 상태",
  "nav.login": "로그인",
  "nav.more": "더보기",
  "nav.moreTitle": "다른 메뉴",
  "nav.home.desc": "이번 주 AI를 얼마나, 어떻게 썼나요?",
  "nav.logs.desc": "언제 어떤 AI로 무엇을 했나요?",
  "nav.stats.desc": "AI를 언제, 얼마나, 무엇에 쓰나요?",
  "nav.people.desc": "팀과 사람별로 어떻게 쓰고 있나요?",
  "nav.connect.desc": "내 AI 도구가 기록을 잘 보내고 있나요?",
  "nav.glossary.desc": "화면에 나온 말이 무슨 뜻인가요?",
  "nav.settings.desc": "무엇이 기록되고, 누가 봤나요?",
  "nav.admin.roles.desc": "누가 무엇을 볼 수 있나요?",
  "nav.admin.policy.desc": "회사는 무엇을, 얼마나 남기나요?",
  "nav.admin.audit.desc": "누가 언제 무엇을 보고 바꿨나요?",
  "nav.admin.system.desc": "기록이 빠짐없이 들어오고 있나요?",
  "rail.collapse": "메뉴 접기",
  "rail.expand": "메뉴 펼치기",
  "rail.help.title": "숫자 읽는 법",
  "rail.help.body": "사용량(토큰)·추정 비용·AI 사용 시간이 무슨 뜻인지 쉬운 말로 봐요.",
  "rail.help.link": "용어집 보기",
  "header.search": "찾기",
  "header.searchLabel": "화면·사람·용어·기록 찾기 (Ctrl K)",
  "header.lang": "언어",
  "header.lang.ko": "한국어",
  "header.lang.en": "English",
  "header.theme.toDark": "다크 테마로 전환",
  "header.theme.toLight": "라이트 테마로 전환",
  "header.bell": "알림",
  "header.bellUnread": "알림, 읽지 않은 알림 {n}개",
  "header.user": "계정 메뉴",
  "menu.settings": "내 기록·동의·설정",
  "menu.theme": "화면 테마",
  "menu.lang": "언어",
  "menu.logout": "로그아웃",
  "theme.light": "라이트",
  "theme.dark": "다크",
  "theme.system": "시스템 설정",
  "theme.changed": "{theme} 테마로 바꿨어요",
  "role.admin": "관리자",
  "role.manager": "매니저",
  "role.member": "일반 사용자",
  "role.auditor": "원문 열람 담당",
  "role.ops": "운영 담당",
  "role.custom_teamlead": "팀 리드(글 보기)",
  "role.admin.desc": "모든 사용자 기록을 보고 역할·권한·정책·연동을 관리해요. 다른 사람의 글은 고정 통제 흐름(사유·다시 로그인 확인·대화 단위 허가)을 거쳐 봐요.",
  "role.manager.desc": "맡은 팀의 사용량과 팀원별 합계를 봐요(기록 당시 소속 기준). 팀원의 질문·답변 글은 기본으로 볼 수 없어요.",
  "role.member.desc": "내 기록과 글을 모두 보고, 기록 수준·동의·도구 연결을 관리해요.",
  "role.auditor.desc": "질문·답변 글을 여는 일만 맡아요(관리 기능 없음). 열 때마다 사유·다시 로그인 확인·대화 단위 허가를 거쳐요.",
  "role.ops.desc": "수집 상태·연동·삭제 요청 처리를 맡아요. 질문·답변 글은 볼 수 없어요.",
  "role.kind.base": "기본 역할",
  "role.kind.preset": "프리셋",
  "role.kind.custom": "사용자 정의",
  "scope.me": "나",
  "scope.team": "우리 팀",
  "scope.all": "전체",
  "scopeVal.off": "꺼짐",
  "scopeVal.self": "본인",
  "scopeVal.team": "팀",
  "scopeVal.all": "전체",
  "period.label": "기간",
  "period.today": "오늘",
  "period.7d": "7일",
  "period.30d": "30일",
  "period.90d": "90일",
  "period.custom": "직접",
  "period.long.today": "오늘",
  "period.long.7d": "최근 7일",
  "period.long.30d": "최근 30일",
  "period.long.90d": "최근 90일",
  "period.long.custom": "고른 기간",
  "period.from": "시작일",
  "period.to": "종료일",
  "period.customTitle": "기간 직접 고르기",
  "period.invalid": "시작일이 종료일보다 늦어요.",
  "period.range": "{from} ~ {to}",
  "period.asOf": "기준 {time}",
  "period.days": "{n}일",
  "source.cli.claude_code": "Claude Code",
  "source.cli.codex": "Codex",
  "source.api.anthropic": "Anthropic API",
  "source.api.openai": "OpenAI API",
  "source.other": "기타",
  "path.cli": "CLI 도구",
  "path.api": "API 키 호출",
  "path.cli.long": "CLI 도구(Claude Code·Codex)",
  "path.api.long": "API 키 호출",
  "provider.anthropic": "Anthropic",
  "provider.openai": "OpenAI",
  "auth.subscription": "구독 로그인",
  "auth.api_key": "API 키 결제",
  "auth.unknown": "확인 안 됨",
  "authMode.label": "결제 방식",
  "authMode.subscription": "구독 로그인",
  "authMode.api_key": "API 키",
  "authMode.unknown": "확인 안 됨",
  "authMode.not_applicable": "해당 없음",
  "authMode.estimate": "추정",
  "authMode.estimateNote": "Claude Code의 결제 방식은 기기마다 마지막으로 확인한 값이라 추정이에요. Codex는 요청마다 확인해요.",
  "authMode.cliOnly": "결제 방식은 CLI 도구에만 있어요. API 키 호출은 ‘해당 없음’으로 묶여요.",
  "mode.direct": "서버로 바로 보내기",
  "mode.helper": "PC 도우미 사용",
  "status.ok": "정상",
  "status.quiet": "한동안 조용함",
  "status.down": "연결 안 됨",
  "status.active": "사용 중",
  "status.grace": "교체 유예",
  "status.revoked": "폐기됨",
  "status.online": "수집 서버 연결됨",
  "status.offline": "수집 서버 연결 끊김",
  "status.success": "성공",
  "status.failed": "실패",
  "status.retry": "재시도",
  "status.refused": "정책상 거절",
  "status.warn": "확인 필요",
  "status.danger": "문제 있음",
  "status.info": "안내",
  "status.idle": "대기",
  "decision.auto": "자동 허용(설정 규칙)",
  "decision.user_accept": "사용자가 허용",
  "decision.user_reject": "사용자가 거절",
  "decision.config_reject": "설정 규칙이 거절",
  "level.label": "기록 수준",
  "level.1": "① 기본 정보",
  "level.2": "② + 질문 글",
  "level.3": "③ + AI 답변 글",
  "level.4": "④ + 작업 상세",
  "level.short.1": "① 기본 정보",
  "level.short.2": "② 질문 글",
  "level.short.3": "③ AI 답변 글",
  "level.short.4": "④ 작업 상세",
  "level.desc.1": "시각·도구·AI 모델·사용량·시간·성공 여부만 남겨요.",
  "level.desc.2": "기본 정보에 더해 질문 글을 남겨요.",
  "level.desc.3": "질문 글에 더해 AI 답변 글을 남겨요.",
  "level.desc.4": "답변 글에 더해 명령·파일 경로·바뀐 내용을 남겨요.",
  "missing.label": "기록 없음",
  "missing.not_sent": "CLI 설정에서 보내지 않음",
  "missing.level": "기록 수준에서 꺼짐",
  "missing.consent": "동의 전",
  "missing.na": "이 사용 방식엔 해당 없음",
  "missing.codex_active": "Codex는 AI 사용 시간을 보내지 않아요",
  "missing.codex_loc": "Codex는 코드 줄 수를 보내지 않아요",
  "missing.api_time": "API 키 호출에는 AI 사용 시간이 없어요",
  "missing.api_files": "API 키 호출에는 파일 작업이 없어요",
  "missing.claude_reasoning": "Claude는 생각에 쓴 양을 따로 보내지 않아요",
  "missing.unofficial": "비공식 값이 오지 않았어요",
  "missing.small_group": "사람이 3명보다 적어 가림",
  "missing.perm": "권한 필요",
  "missing.not_parsed": "지원 여부 확인 중",
  "missing.no_prev": "직전 기간 기록 없음",
  "missing.no_data": "이 기간에는 기록이 없어요",
  "missing.zero": "0 (확인됨)",
  "common.cancel": "취소",
  "common.ok": "확인",
  "common.apply": "적용",
  "common.reset": "기본값으로",
  "common.options": "옵션",
  "common.less": "접기",
  "common.copy": "복사",
  "common.copied": "복사했어요",
  "common.copyFail": "복사하지 못했어요. 글을 직접 골라 복사하세요.",
  "common.retry": "다시 시도",
  "common.goHome": "홈으로",
  "common.viewTable": "표로 보기",
  "common.viewChart": "차트로 보기",
  "common.loading": "불러오는 중",
  "common.updated": "{time} 갱신",
  "common.basis": "기준 {n}건",
  "common.source": "출처",
  "common.on": "켜짐",
  "common.off": "꺼짐",
  "common.all": "전체",
  "common.none": "없음",
  "common.yes": "예",
  "common.no": "아니요",
  "common.details": "자세히",
  "common.dismiss": "알림 닫기",
  "common.search": "검색",
  "common.noResult": "맞는 결과가 없어요",
  "common.tryOther": "다른 낱말로 찾아보세요.",
  "common.estimated": "추정",
  "common.unofficial": "비공식",
  "common.truncated": "잘림",
  "common.count": "{n}건",
  "common.people": "{n}명",
  "common.items": "{n}개",
  "common.times": "{n}회",
  "common.lines": "{n}줄",
  "common.open": "열기",
  "common.new": "새로",
  "common.me": "나",
  "common.you": "(나)",
  "common.sample": "예시",
  "common.and": "·",
  "state.notReady.title": "이 화면은 준비 중이에요",
  "state.notReady.desc": "아직 등록되지 않은 화면이에요({route}). 화면 파일을 추가하면 여기에 나타나요.",
  "state.notFound.page": "찾을 수 없는 화면",
  "state.notFound.title": "이 화면을 찾을 수 없어요",
  "state.notFound.desc": "주소({route})가 맞는지 확인하세요. 메뉴나 찾기(Ctrl K)로 옮길 수 있어요.",
  "state.noAccess.title": "이 화면을 볼 권한이 없어요",
  "state.noAccess.desc": "지금 역할({role})로는 볼 수 없어요. 필요하면 관리자에게 권한을 요청하세요.",
  "state.error.title": "화면을 그리지 못했어요",
  "state.error.desc": "잠시 뒤 다시 시도하세요. 문제가 계속되면 관리자에게 알려 주세요.",
  "state.emptyTitle": "아직 기록이 없어요",
  "state.emptyDesc": "CLI 도구나 API 키를 연결하면 여기에 사용 기록이 쌓여요.",
  "state.loadError": "불러오지 못했어요",
  "palette.title": "찾기",
  "palette.placeholder": "화면·사람·용어·기록 찾기",
  "palette.group.screens": "화면",
  "palette.group.people": "사람",
  "palette.group.terms": "용어",
  "palette.group.logs": "기록",
  "palette.hint.move": "이동",
  "palette.hint.open": "열기",
  "palette.hint.close": "닫기",
  "palette.empty": "‘{q}’ 결과가 없어요",
  "palette.emptyHint": "초성(예: ㅌㅋ)이나 영어로도 찾을 수 있어요.",
  "bell.title": "알림",
  "bell.readAll": "모두 읽음",
  "bell.empty": "새 알림이 없어요",
  "bell.allRead": "알림을 모두 읽음으로 바꿨어요",
  "footer.last": "마지막 기록 {rel}",
  "footer.tz": "저장은 UTC, 화면은 한국 시간",
  "access.title": "글을 보려면 사유를 남겨 주세요",
  "access.kicker": "글 열람 고정 통제 흐름",
  "access.desc": "{name} 님의 대화 #{no}예요. 열람 사실은 당사자 화면과 열람·변경 이력에 남고, 이 대화만 {min}분 동안 볼 수 있어요.",
  "access.reasonLabel": "사유(10자 이상)",
  "access.reasonPh": "예: 보안 점검 요청에 따른 확인(점검 번호 함께 적기)",
  "access.confirm": "사유 남기고 보기",
  "access.tooShort": "사유를 10자 이상 적어 주세요.",
  "access.granted": "열람 기록이 남았고 당사자에게 표시돼요. 이 대화를 {min}분 동안 볼 수 있어요.",
  "access.needReason": "글은 저장되어 있어요 · 사유를 남기면 볼 수 있어요",
  "access.request": "사유 입력 후 보기",
  "access.left": "{min}분 남음",
  "access.ownerNotice": "당사자 화면의 “누가 내 기록을 봤나요”에 남아요.",
  "opt.title": "보기 옵션",
  "opt.button": "옵션",
  "opt.buttonLabel": "{title} 보기 옵션",
  "opt.period": "기간",
  "opt.groupBy": "묶는 기준",
  "opt.chartType": "차트 형태",
  "opt.metrics": "지표",
  "opt.metricsMax": "최대 {n}개까지 고를 수 있어요",
  "opt.topN": "상위 몇 개",
  "opt.compare": "직전 기간과 비교",
  "opt.compareMode": "비교 방식",
  "opt.compare.prev": "직전 같은 기간",
  "opt.compare.avg": "직전 기간 평균선",
  "opt.toggles": "표시",
  "opt.unit": "단위",
  "opt.unit.raw": "토큰",
  "opt.unit.1e4": "만 토큰",
  "opt.unit.1e6": "백만 토큰",
  "opt.changed": "기본값과 다른 옵션이 있어요",
  "opt.applied": "보기 옵션을 적용했어요",
  "chartType.bar": "막대",
  "chartType.line": "선",
  "chartType.area": "영역",
  "chartType.donut": "도넛",
  "chartType.table": "표",
  "groupBy.none": "묶지 않음",
  "groupBy.source": "도구",
  "groupBy.tool": "AI 회사",
  "groupBy.path": "사용 방식",
  "groupBy.model": "AI 모델",
  "groupBy.user": "사람",
  "groupBy.team": "팀",
  "groupBy.project": "프로젝트",
  "groupBy.weekday": "요일",
  "groupBy.hour": "시간대",
  "groupBy.fileExt": "파일 종류",
  "groupBy.toolName": "AI가 한 작업",
  "bucket.hour": "시간",
  "bucket.day": "일",
  "bucket.week": "주",
  "bucket.month": "월",
  "metric.prompts": "질문 수",
  "metric.sessions": "대화 수",
  "metric.requests": "AI 요청 수",
  "metric.tokens": "사용량(토큰)",
  "metric.tokens.in": "새로 읽음",
  "metric.tokens.out": "AI가 쓴 양",
  "metric.tokens.cacheRead": "캐시에서 읽음",
  "metric.tokens.cacheWrite": "캐시에 저장",
  "metric.tokens.reasoning": "생각에 쓴 양(쓴 양에 포함)",
  "metric.costUsd": "추정 비용",
  "metric.activeMs": "AI 사용 시간",
  "metric.durationMs": "대화가 열려 있던 시간",
  "metric.files.read": "AI가 열어 본 파일",
  "metric.files.edited": "AI가 고친 파일",
  "metric.lines.added": "추가 줄",
  "metric.lines.removed": "삭제 줄",
  "metric.tools": "AI가 한 작업",
  "metric.commands": "명령 실행",
  "metric.errors": "오류",
  "metric.rejects": "거절",
  "metric.latency.p50": "응답 대기(보통)",
  "metric.latency.p95": "응답 대기(느릴 때)",
  "unit.tokens": "토큰",
  "unit.count": "건",
  "unit.people": "명",
  "unit.lines": "줄",
  "unit.files": "개",
  "unit.times": "회",
  "costKind.cli_estimate": "CLI 도구 추정",
  "costKind.unofficial": "비공식",
  "costKind.gateway_price": "단가표 계산",
  "costKind.org_bill": "조직 청구",
  "cost.notBill": "청구서 아님",
  "cost.noSum": "계산 방식이 달라 서로 더하지 않아요",
  "delta.up": "직전 기간보다 {p} 많음",
  "delta.down": "직전 기간보다 {p} 적음",
  "delta.flat": "직전 기간과 비슷함",
  "delta.new": "직전 기간에는 없었음",
  "delta.vsPrev": "직전 기간보다",
  "perm.audit.view": "열람·변경 이력 보기",
  "perm.stats.export.desc": "통계와 목록을 CSV·JSON으로 내보내요.",
  "perm.connections.manage.desc": "CLI·PC 연결과 연결 토큰을 관리해요.",
  "diff.fold": "바뀌지 않은 {n}줄 보기",
  "diff.unfolded": "바뀌지 않은 {n}줄을 펼쳤어요",
  "diff.copy": "{path} 바뀐 내용 복사",
  "diff.truncated": "보낸 값이 잘려 일부만 남았어요",
  "diff.added": "{n}줄 추가",
  "diff.removed": "{n}줄 삭제",
  "diff.del": "지운 줄",
  "diff.add": "더한 줄",
  "diff.empty": "바뀐 내용이 없어요",
  "code.lang.powershell": "PowerShell",
  "code.lang.bash": "Bash",
  "code.lang.json": "JSON",
  "code.lang.javascript": "JavaScript",
  "code.lang.diff": "패치",
  "code.lang.text": "텍스트",
  "code.lines": "{n}줄",
  "code.more": "전체 펼치기 · {n}줄",
  "code.less": "접기",
  "code.open": "크게 보기",
  "code.copy": "내용 복사",
  "code.title": "실행 내용 전체 보기",
  "code.body": "{lang} 내용",
  "fileTree.label": "AI가 열어 본·고친 파일",
  "fileTree.read": "열어 봄",
  "fileTree.edit": "고침",
  "fileTree.create": "새로 만듦",
  "fileTree.estimated": "추정",
  "fileTree.estimatedTip": "셸 명령 글에서 뽑은 추정 경로예요. 빠짐없다고 보장하지 않아요.",
  "fileTree.folder": "{name} 폴더",
  "tl.prompt": "질문",
  "tl.request": "AI 호출",
  "tl.tool": "AI가 한 작업",
  "tl.command": "명령",
  "tl.answer": "AI 답변",
  "tl.error": "오류",
  "tl.decision": "허용·거절",
  "tl.system": "실행 환경",
  "logcat.tool": "도구 실행",
  "logcat.command": "명령 실행",
  "logcat.decision": "허용·거절",
  "logcat.error": "오류·재시도",
  "logcat.system": "실행 환경",
  "logcat.filterLabel": "기록 종류",
  "logcat.empty": "고른 종류의 기록이 없어요",
  "json.expand": "펼치기",
  "json.collapse": "접기",
  "json.items": "{n}개 항목",
  "redact.label": "가림: {kind}",
  "redact.email": "이메일",
  "redact.phone": "전화번호",
  "redact.secret": "비밀값",
  "redact.card": "카드 번호",
  "redact.rrn": "주민등록번호",
  "redact.path": "비밀 파일 경로",
  "redact.name": "이름",
  "wizard.label": "진행 단계",
  "wizard.step": "{n}단계",
  "wizard.doneStep": "{label} (마침)",
  "permCell.locked": "필수 권한이라 바꿀 수 없어요",
  "permCell.changed": "{role} · {perm} 권한을 {value}(으)로 바꿨어요",
  "permCell.hint": "칸을 누르면 꺼짐 → 본인 → 팀 → 전체 순서로 바뀌어요.",
  "perm.matrixLabel": "역할별 권한 표",
  "table.rowOpen": "{title} 열기",
  "table.region": "{label} 표",
  "table.cols.more": "열 {n}개 더 보기",
  "table.cols.less": "열 줄여 보기",
  "chart.avg": "평균",
  "chart.prev": "직전 기간",
  "chart.total": "합계",
  "chart.other": "기타",
  "chart.less": "적음",
  "chart.more": "많음",
  "chart.keys": "방향키로 항목을 옮겨 다닐 수 있어요",
  "chart.noData": "이 기간에는 기록이 없어요",
  "chart.summary": "{title}. 항목 {n}개, 가장 큰 값 {max}({at}).",
  "chart.summaryEmpty": "{title}. 기록이 없어요.",
  "chart.hidden": "사람이 3명보다 적어 이 그림을 숨겼어요",
  "chart.legendToggle": "{label} 보이기/숨기기",
  "chart.isolate": "{label}만 보기",
  "chart.target": "목표",
  "chart.share": "비중",
  "kpi.vsPrev": "직전 기간보다",
  "nav.admin.cost": "비용 정책",
  "nav.admin.cost.desc": "비용은 어떻게 계산하고 관리하나요?",
  "nav.settings.page": "내 기록·동의·설정",
  "role.manager.long": "매니저(팀 관리)",
  "role.content_reviewer": "원문 열람 담당",
  "role.log_reviewer": "감사 기록 검토자",
  "role.stats_viewer": "통계만 보기",
  "role.delegated_admin": "위임 관리자",
  "role.content_reviewer.desc": "질문·답변 글을 여는 일만 맡아요(관리 기능 없음). 열 때마다 사유·다시 로그인 확인·대화 단위 허가를 거치고, 당사자의 ‘누가 내 기록을 봤나요’에 남아요.",
  "role.log_reviewer.desc": "열람·변경 이력과 기본 정보만 읽어요. 글을 열거나 실명·글을 내보낼 수 없고, 월간 점검을 맡아요.",
  "role.stats_viewer.desc": "이름 없는 집계만 봐요. 대화 목록은 열 수 없고, 3명보다 적은 팀은 합쳐서 보여요.",
  "role.delegated_admin.desc": "지정된 팀 안에서 사람·역할을 관리해요. 자기가 가진 권한보다 많이 줄 수 없어요.",
  "role.custom_teamlead.desc": "매니저 역할을 복사해 팀원 질문·답변 글 보기(팀)를 더한 사용자 정의 역할이에요(2인 승인 필요).",
  "role.kind.system": "기본 역할(읽기 전용)",
  "role.copyToEdit": "복사해서 고치세요",
  "permCat.usage": "사용량 보기",
  "permCat.records": "기록 목록·사람",
  "permCat.content": "질문·답변 글",
  "permCat.work": "작업 상세",
  "permCat.export": "내보내기",
  "permCat.admin": "관리 기능",
  "permCat.view": "사용량 보기",
  "permCat.usage.desc": "질문 수·사용량·비용·통계 같은 숫자를 봐요.",
  "permCat.records.desc": "기록 목록·사람·실명·개인별 상세를 봐요.",
  "permCat.content.desc": "질문 글과 AI 답변 글을 봐요. 남의 글은 고정 통제 흐름을 거쳐요.",
  "permCat.work.desc": "파일·바뀐 내용·명령·도구 결과·기술 상세를 봐요.",
  "permCat.export.desc": "집계·행·실명·글을 내보내요. 기본은 가명·글 제외예요.",
  "permCat.admin.desc": "사람·팀·역할·정책·연동·삭제·이력을 관리해요.",
  "perm.usage.view": "사용량 보기",
  "perm.usage.view.desc": "홈·통계의 질문 수·사용량·시간·AI 모델을 봐요.",
  "perm.cost.view": "비용 보기",
  "perm.cost.view.desc": "CLI 도구 추정·단가표 계산·조직 청구 금액을 봐요.",
  "perm.stats.view": "통계 보기",
  "perm.stats.view.desc": "통계 화면과 사람·팀 화면의 팀 탭을 봐요.",
  "perm.logs.list": "기록 목록 보기",
  "perm.logs.list.desc": "사용 기록 목록과 기록 상세의 기본 정보를 봐요. 글은 들어 있지 않아요.",
  "perm.people.view": "사람·팀 보기",
  "perm.people.view.desc": "사람 탭·사람 비교·팀 연결 상태를 봐요.",
  "perm.people.identity": "실명 보기",
  "perm.people.identity.desc": "실명을 봐요. 없으면 가명(사용자 #1F3A)으로 보여요.",
  "perm.people.individual": "개인별 상세 보기",
  "perm.people.individual.desc": "사람 상세 화면을 열어요. 열 때마다 이력이 남고 당사자에게 표시돼요.",
  "perm.logs.prompt": "질문 글 보기",
  "perm.logs.prompt.desc": "질문 글을 봐요. 남의 글은 사유·다시 로그인 확인·대화 단위 허가를 거쳐요.",
  "perm.logs.answer": "AI 답변 글 보기",
  "perm.logs.answer.desc": "AI 답변 글을 봐요. 남의 글은 고정 통제 흐름을 거쳐요.",
  "perm.logs.files": "파일 보기",
  "perm.logs.files.desc": "AI가 열어 본·고친 파일을 봐요. 라벨은 바로, 전체 경로는 고정 통제 흐름 뒤에 보여요.",
  "perm.logs.diff": "바뀐 내용 보기",
  "perm.logs.diff.desc": "파일에서 바뀐 줄(추가·삭제)을 봐요.",
  "perm.logs.commands": "명령 전문 보기",
  "perm.logs.commands.desc": "AI가 실행한 명령 전체를 봐요. 프로그램 이름은 기본 정보예요.",
  "perm.logs.tool_output": "도구 결과 보기",
  "perm.logs.tool_output.desc": "파일 내용·명령 출력 일부를 봐요.",
  "perm.logs.raw": "기술 상세 보기",
  "perm.logs.raw.desc": "다른 기록 권한으로 걸러진 원본 데이터를 봐요.",
  "perm.export.aggregate": "집계 내보내기",
  "perm.export.aggregate.desc": "통계 집계를 CSV·JSON으로 내보내요.",
  "perm.export.rows": "행 내보내기(가명)",
  "perm.export.rows.desc": "기록 행을 가명으로 내보내요.",
  "perm.export.identity": "실명 포함 내보내기",
  "perm.export.identity.desc": "실명을 넣어 내보내요. 사유·약정·당사자 표시가 붙어요.",
  "perm.export.content": "글 포함 내보내기",
  "perm.export.content.desc": "질문·답변 글을 넣어 내보내요. 사유·약정·당사자 표시가 붙어요.",
  "perm.people.manage": "사용자 관리",
  "perm.people.manage.desc": "사용자를 추가·초대·정지·복구하고 임시 비밀번호를 줘요.",
  "perm.teams.manage": "팀 관리",
  "perm.teams.manage.desc": "팀을 만들고 옮기고 보관하며 매니저를 지정해요.",
  "perm.roles.manage": "역할·권한 관리",
  "perm.roles.manage.desc": "전체 범위는 역할 정의를 고치고, 팀 범위는 역할을 주고 거둬요.",
  "perm.policy.manage": "기록 정책 관리",
  "perm.policy.manage.desc": "회사 상한·가림 규칙·보관 값·열람 통제 값과 단가표를 정해요.",
  "perm.notice.manage": "안내문 관리",
  "perm.notice.manage.desc": "안내문·약정문을 고치고 게시해요.",
  "perm.integrations.manage": "연동 관리",
  "perm.integrations.manage.desc": "게이트웨이·조직 보고서 연동과 AI 회사 키 등록·교체를 맡아요.",
  "perm.keys.view": "API 키 등록부 보기",
  "perm.keys.view.desc": "키의 끝 4자리·소유자·상태를 봐요.",
  "perm.devices.revoke_any": "다른 사람 연결 끊기",
  "perm.devices.revoke_any.desc": "다른 사람의 수집 전용 토큰·기기를 끊어요.",
  "perm.budget.manage": "예산·한도 관리",
  "perm.budget.manage.desc": "(선택 모듈) 팀별 예산·한도를 정해요.",
  "perm.deletion.process": "삭제 요청 처리",
  "perm.deletion.process.desc": "삭제 요청을 삭제·보류·반려해요.",
  "perm.legal_hold.manage": "법적 보관 관리",
  "perm.legal_hold.manage.desc": "법적 보관(legal hold)을 지정하고 풀어요.",
  "perm.access.approve": "2인 승인",
  "perm.access.approve.desc": "권한 변경·조사 건을 두 번째 사람으로 승인해요.",
  "perm.audit.view.desc": "누가 언제 무엇을 보고 바꿨는지 이력을 봐요.",
  "perm.audit.verify": "위변조 검사",
  "perm.audit.verify.desc": "이력의 해시 체인과 외부 고정점을 맞춰 봐요.",
  "perm.retention.manage": "보관 작업 관리",
  "perm.retention.manage.desc": "보관 기간이 지난 기록을 지우는 작업을 실행하고 결과를 봐요.",
  "perm.glossary.edit": "용어집 편집",
  "perm.glossary.edit.desc": "용어 설명·예시·외부 링크를 고쳐요.",
  "perm.system.view": "수집 상태 보기",
  "perm.system.view.desc": "수집 경로별 받은 건수·공백·버전 지원을 봐요.",
  "perm.stats.export": "집계 내보내기",
  "perm.connections.manage": "다른 사람 연결 끊기",
  "perm.flowNote": "* 본인 기록이 아니면 고정 통제 흐름(사유·다시 로그인 확인·대화 단위 허가)을 거쳐요",
  "perm.dualNote": "글·실명·내보내기 권한이 늘어나면 2인 승인이 필요해요",
  "scope.label": "보기 범위",
  "scope.allTeams": "모든 팀",
  "scope.teamFilter": "팀",
  "scope.teamFilterLabel": "전체 안에서 팀 고르기",
  "method.label": "사용 방식",
  "method.all": "전체",
  "method.cli": "CLI 도구",
  "method.api": "API 키 호출",
  "method.other": "기타",
  "surface.label": "실행 위치",
  "surface.terminal": "터미널",
  "surface.ide": "편집기 확장",
  "surface.desktop": "데스크톱 앱",
  "surface.sdk": "SDK",
  "surface.automation": "자동화",
  "surface.unknown": "미확인",
  "surface.not_applicable": "해당 없음",
  "effort.label": "생각 깊이",
  "effort.low": "낮음",
  "effort.medium": "보통",
  "effort.high": "높음",
  "effort.unknown": "확인 안 됨",
  "effort.not_applicable": "해당 없음",
  "actor.user": "사람",
  "actor.config": "설정 규칙",
  "actor.hook": "정책 훅",
  "actor.none": "주체 기록 없음",
  "decisionKind.allow": "허용",
  "decisionKind.reject": "거절",
  "errorKind.rate_limit": "한도 초과(429)",
  "errorKind.server": "서버 오류(5xx)",
  "errorKind.refusal": "정책상 거부",
  "errorKind.tool_fail": "도구 실패",
  "actionKind.read": "파일 읽기",
  "actionKind.edit": "파일 수정",
  "actionKind.write": "파일 쓰기",
  "actionKind.command": "명령 실행",
  "actionKind.search": "내용 검색",
  "actionKind.find": "파일 찾기",
  "actionKind.web": "웹 조회·검색",
  "actionKind.delegate": "하위 작업 위임",
  "actionKind.plan": "작업 계획·할 일",
  "actionKind.skill": "스킬 실행",
  "actionKind.mcp": "외부 도구(MCP)",
  "actionKind.other": "기타 작업",
  "groupBy.method": "사용 방식",
  "groupBy.surface": "실행 위치",
  "groupBy.effort": "생각 깊이",
  "groupBy.teamAtEvent": "팀(기록 당시)",
  "groupBy.teamNow": "팀(현재)",
  "groupBy.person": "사람",
  "groupBy.folder": "폴더",
  "groupBy.actor": "결정한 쪽",
  "groupBy.decision": "허용·거절",
  "groupBy.errorKind": "오류 분류",
  "groupBy.costKind": "비용 종류",
  "groupBy.actionKind": "작업 종류",
  "groupBy.apiKey": "API 키",
  "groupBy.provider": "AI 회사",
  "metric.questionsLen": "질문 길이",
  "metric.slashCommands": "/명령 수",
  "metric.cacheReuseRatio": "캐시 다시 쓴 비율",
  "metric.filesByExt": "확장자별 파일 수",
  "metric.folders": "폴더별 파일 수",
  "metric.patches": "패치 건수",
  "metric.firstToken": "첫 글자까지",
  "metric.effortShare": "생각 깊이 분포",
  "metric.decisionsBy": "허용·거절(결정한 쪽)",
  "metric.errorKinds": "오류 분류",
  "metric.gatewayCalls": "게이트웨이 호출 수",
  "metric.orgReport": "조직 보고서",
  "metric.costByKind": "비용 종류별 금액",
  "agg.folderHidden": "폴더",
  "agg.rootFolder": "(맨 위 폴더)",
  "agg.blocked.permission": "사람 기준 비교는 사람·팀 보기 권한이 있어야 써요.",
  "agg.blocked.no_person_metric": "이 지표는 사람 기준으로 비교하지 않아요(근무·성과 평가에 쓰지 않아요).",
  "conn.ok": "연결됨",
  "conn.quiet": "한동안 조용함",
  "conn.down": "연결 안 됨",
  "conn.off": "기록 꺼짐",
  "conn.revoked": "연결 해제됨",
  "conn.problem": "오류",
  "conn.rule": "연결됨 = 마지막 수신 4시간 이내 · 한동안 조용함 = 4시간~3일 · 연결 안 됨 = 3일 초과",
  "status.connected": "연결됨",
  "consent.item.basic": "기본 정보",
  "consent.item.prompt": "질문 글",
  "consent.item.answer": "AI 답변 글",
  "consent.item.work_detail": "작업 상세",
  "consent.item.tool_output": "도구 결과",
  "consent.item.server_upload": "회사 서버로 보내기",
  "consent.capOff": "회사 상한에서 꺼져 있어요",
  "consent.helperOnly": "PC 도우미를 쓰는 사람만 골라요",
  "consent.reconsent": "안내문 {v}에 다시 동의해야 해요",
  "consent.paused": "{until}까지 기록을 잠시 멈췄어요",
  "reasonCat.label": "사유 범주",
  "reasonCat.security_incident": "보안 사고 조사",
  "reasonCat.user_support": "사용자 지원 요청",
  "reasonCat.outage": "장애 조사",
  "reasonCat.other": "기타",
  "auditKind.login": "로그인",
  "auditKind.permission": "권한 변경",
  "auditKind.policy": "정책 변경",
  "auditKind.content_view": "글 열람",
  "auditKind.person_view": "개인별 보기",
  "auditKind.export": "내보내기",
  "auditKind.consent": "동의 변경",
  "auditKind.deletion": "삭제 처리",
  "auditKind.legal_hold": "법적 보관",
  "auditKind.key_rotation": "키 교체",
  "auditKind.glossary": "용어 변경",
  "auditKind.other": "기타",
  "result.success": "성공",
  "result.denied": "거부",
  "result.failed": "실패",
  "result.pending": "대기",
  "support.level.verified": "실측 확인",
  "support.level.source": "소스 확인",
  "support.level.doc": "문서 확인",
  "support.status.conditional": "조건부",
  "support.status.unofficial": "비공식",
  "support.status.unsupported": "미지원",
  "support.status.na": "해당 없음",
  "support.status.checking": "확인 중",
  "support.tool.claude_code": "Claude Code",
  "support.tool.codex": "Codex",
  "support.tool.anthropic_api": "Anthropic API",
  "support.tool.openai_api": "OpenAI API",
  "support.item.prompt": "질문 글",
  "support.item.answer": "AI 답변 글",
  "support.item.tool_detail": "도구 상세",
  "support.item.active_time": "AI 사용 시간",
  "support.item.lines": "코드 줄",
  "support.item.reasoning": "생각에 쓴 양",
  "support.item.cache_write": "캐시에 저장",
  "support.item.cost": "비용",
  "value.none": "기록 없음",
  "value.partial": "일부만",
  "value.zero": "0(확인됨)",
  "value.goSupport": "지원표에서 보기",
  "value.goFix": "해결 방법 보기",
  "reason.consent_before": "동의 전",
  "reason.paused": "일시 중지",
  "reason.level_off": "기록 수준에서 꺼짐",
  "reason.cli_not_sent": "CLI 설정에서 보내지 않음",
  "reason.tool_not_sent": "이 도구는 보내지 않음",
  "reason.not_applicable": "이 사용 방식엔 해당 없음",
  "reason.version_checking": "지원 여부 확인 중",
  "reason.old_version": "지원 버전보다 낮음",
  "reason.expired": "보관 기간 지나 삭제",
  "reason.gap": "서버가 받지 못한 구간",
  "reason.permission": "권한 필요",
  "reason.small_group": "사람이 3명보다 적어 가림",
  "reason.verifying": "검증 중",
  "reason.consent_before.help": "안내문에 동의하기 전이거나, 안내문이 바뀌어 다시 동의해야 하는 동안의 기록은 저장하지 않아요.",
  "reason.paused.help": "본인이 기록을 잠시 멈춘 동안이에요.",
  "reason.level_off.help": "고른 기록 수준(또는 회사 상한)에 이 항목이 없어요.",
  "reason.cli_not_sent.help": "기록 수준은 켰지만 PC의 CLI 설정이 이 값을 보내지 않아요. 설정을 다시 받으세요.",
  "reason.tool_not_sent.help": "도구가 이 값을 원래 보내지 않아요.",
  "reason.not_applicable.help": "이 사용 방식에는 이런 값이 없어요.",
  "reason.version_checking.help": "아직 지원표에서 확인하지 않은 새 버전이에요.",
  "reason.old_version.help": "최소 지원 버전(Claude Code 2.1.300·Codex 0.162.1)보다 낮은 CLI가 보낸 기록이라 글·작업 상세를 받지 않았어요.",
  "reason.expired.help": "보관 기간이 지나 자동으로 지웠어요(글 30일, 사용량·기본 정보 180일).",
  "reason.gap.help": "수집 서버가 멈췄거나 네트워크 문제로 받지 못한 시간대예요.",
  "reason.permission.help": "값은 있지만 지금 역할로는 볼 수 없어요.",
  "reason.small_group.help": "조건에 남은 사람이 3명보다 적으면 누구인지 짐작되지 않게 숨겨요. 본인 기록은 숨기지 않아요.",
  "reason.verifying.help": "값은 있지만 출처끼리 합계가 아직 맞지 않아 검증하고 있어요.",
  "partial.truncated": "잘림",
  "partial.estimated_link": "추정 연결",
  "partial.estimated": "추정",
  "partial.unofficial": "비공식",
  "partial.verifying": "검증 중",
  "partial.truncated.help": "도구가 값을 일정 길이까지만 보냈어요(예: Claude Code는 값마다 앞 128자까지만 보내요).",
  "partial.estimated_link.help": "질문과 AI 호출을 정확한 번호 대신 시간 순서로 이어 붙였어요.",
  "partial.estimated.help": "셸 명령이나 패치에서 뽑은 추정 값이에요. 빠짐없다고 보장하지 않아요.",
  "partial.unofficial.help": "공식 문서 목록에 없는 값이에요(예: Codex 답변 글·자체 추정 비용).",
  "partial.verifying.help": "출처끼리 합계가 아직 맞지 않아 검증하고 있어요(예: Codex 사용량).",
  "reasonDetail.codex_active": "Codex는 AI 사용 시간을 보내지 않아요",
  "reasonDetail.claude_reasoning": "Claude는 생각에 쓴 양을 따로 보내지 않아요",
  "reasonDetail.anthropic_reasoning": "Anthropic API의 생각에 쓴 양은 지원 여부를 확인하고 있어요",
  "reasonDetail.codex_loc": "Codex는 코드 줄 수를 보내지 않아요(패치에서 센 추정만 있어요)",
  "reasonDetail.openai_cache_write": "OpenAI API는 캐시에 저장한 양을 보내지 않아요",
  "reasonDetail.codex_cache_write": "Codex의 캐시에 저장은 입력에 들어 있는지 확인 중이라 쌓지 않아요",
  "reasonDetail.codex_tokens": "Codex 사용량은 CLI 요약과 기록 합계의 차이를 밝히는 중이에요",
  "reasonDetail.codex_cost": "Codex 비용은 비공식 값이라 오지 않을 수 있어요",
  "reasonDetail.codex_slash": "Codex는 /명령을 따로 보내지 않아요",
  "reasonDetail.codex_answers": "Codex 답변 글은 비공식 설정을 켜야 와요",
  "reasonDetail.api_time": "API 키 호출에는 AI 사용 시간이 없어요",
  "reasonDetail.api_files": "API 키 호출에는 파일 작업이 없어요",
  "reasonDetail.api_duration": "API 키 호출은 대화 시간을 알 수 없어요",
  "reasonDetail.metrics_off": "숫자 지표 보내기가 꺼져 있어요",
  "card.basis": "기준 {n}건",
  "card.excluded": "제외 {n}건",
  "card.excludedPeople": "제외 {p}명·{n}건",
  "card.cond": "조건: {cond}",
  "card.updated": "{time} 갱신(한국 시간)",
  "card.noRecord": "기록 없음 ≠ 안 씀",
  "card.help": "{title} 도움말",
  "card.helpTip": "이 카드 설명 보기",
  "card.onlyThis": "이 카드만: {v}",
  "card.followCommon": "공통 조건 따르기",
  "card.statsLink": "통계에서 자세히",
  "card.notMean": "기록이 없다고 AI를 안 쓴 건 아니에요.",
  "card.emptyWhat": "이 조건에 맞는 기록이 없어요.",
  "card.emptyNext": "조건 풀기",
  "card.loadError": "불러오지 못했어요",
  "card.loadErrorDesc": "잠시 뒤 다시 시도하세요.",
  "card.formula": "계산식",
  "card.addView": "저장한 보기에 추가",
  "card.export": "내보내기",
  "kpi.vsBase": "{base}보다",
  "statsItem.prompts": "질문",
  "statsItem.usage": "사용량",
  "statsItem.files": "열어 본·고친 파일",
  "statsItem.changes": "바뀐 내용",
  "statsItem.time": "시간",
  "statsItem.models": "AI 모델·생각 깊이",
  "statsItem.actions": "AI가 한 작업·오류",
  "statsItem.api": "API·비용",
  "delta.s.up": "{base}보다 {p}% 늘었어요({prev}→{cur})",
  "delta.s.down": "{base}보다 {p}% 줄었어요({prev}→{cur})",
  "delta.s.flat": "{base}{josa} 비슷해요({prev}→{cur})",
  "delta.s.new": "{base}에는 없었어요(0→{cur})",
  "delta.base.today": "어제",
  "delta.base.day": "전날",
  "delta.base.days": "직전 {n}일",
  "delta.base.week": "지난주",
  "delta.base.prev": "직전 기간",
  "delta.chip.up": "▲ {p}%",
  "delta.chip.down": "▼ {p}%",
  "delta.chip.flat": "비슷함",
  "delta.chip.new": "새로",
  "fixed.notEval": "사용 통계는 비용·보안 관리를 위한 것이며 근무·성과 평가에 쓰지 않아요",
  "fixed.activeTime": "근무 시간·성과 지표가 아니에요",
  "fixed.duration": "작업 시간이 아니에요",
  "fixed.lines": "AI 기여율이 아니에요",
  "fixed.cost": "추정 · 청구서 아님",
  "fixed.orgBill": "청구 기준 · 하루 단위 · 사람별 아님",
  "fixed.decision": "허용이 실행 성공을 뜻하지는 않아요",
  "person.pseudonymNote": "실명 권한이 없어 가명으로 보여요",
  "term.open": "{term} 설명 열기",
  "term.more": "용어집에서 자세히",
  "term.external": "외부 설명",
  "term.lang.ko": "한국어",
  "term.lang.en": "영문",
  "term.manual": "사용 설명서 절은 준비 중이에요",
  "term.linkHidden": "외부 링크는 확인 중이라 숨겼어요",
  "term.plain": "쉬운 말",
  "term.original": "원래 용어",
  "term.clickHint": "누르면 자세한 설명이 열려요",
  "help.button": "도움말",
  "help.title": "도움말",
  "help.kicker": "이 화면을 읽는 법",
  "help.read.title": "숫자 읽는 법",
  "help.read.1": "큰 수는 만·억으로 줄여요(1.2만 토큰 = 약 12,000토큰). 줄인 숫자에 마우스를 올리면 전체 값이 보여요.",
  "help.read.2": "사용량은 겹치지 않는 4종(새로 읽음·캐시에서 읽음·캐시에 저장·AI가 쓴 양)을 더한 값이에요. 생각에 쓴 양은 AI가 쓴 양에 이미 들어 있어요.",
  "help.read.3": "추정 비용은 청구서가 아니에요. 계산 방식이 다른 비용은 서로 더하지 않아요.",
  "help.read.4": "응답 대기는 ‘보통’(절반이 이 안에 끝남)과 ‘느릴 때’(100건 중 95건이 이 안에 끝남)로 보여요.",
  "help.read.5": "그림의 점선은 직전 기간(같은 길이의 바로 앞 기간)이에요. CLI 도구는 채움, API 키 호출은 빗금이에요.",
  "help.empty.title": "왜 비어 있나요",
  "help.empty.lead": "칸이 비면 0 대신 ‘기록 없음 · 이유’를 보여 줘요. 기록이 없다고 AI를 안 쓴 것은 아니에요.",
  "help.source.title": "기록은 어디서 오나요",
  "help.source.lead": "기록이 들어오는 길은 여섯 가지예요. 길마다 받을 수 있는 값이 달라요.",
  "help.source.C1": "CLI 공식 기록",
  "help.source.C1.desc": "내 PC의 Claude Code·Codex가 회사 수집 서버로 바로 보내요.",
  "help.source.C2": "PC 도우미",
  "help.source.C2.desc": "내 PC에 잠시 모았다가 보내요(선택 모듈, 지금은 꺼짐).",
  "help.source.C3": "API 게이트웨이",
  "help.source.C3.desc": "앱·스크립트가 회사 게이트웨이를 거쳐 AI를 부를 때 남아요.",
  "help.source.C4": "조직 보고서",
  "help.source.C4.desc": "AI 회사가 하루 단위로 알려 주는 사용량·비용이에요(사람별 아님).",
  "help.source.C5": "이 앱의 기록",
  "help.source.C5.desc": "로그인·권한·정책·동의·열람 같은 이 앱 안의 일이에요.",
  "help.source.C6": "정밀 기록",
  "help.source.C6.desc": "훅·대화 파일로 더 자세히 남겨요(나중에 결정, 지금은 꺼짐).",
  "help.source.on": "켜짐",
  "help.source.off": "꺼짐",
  "help.flow.pc": "내 PC의 AI 도구",
  "help.flow.app": "앱·스크립트",
  "help.flow.server": "회사 수집 서버",
  "help.flow.gateway": "회사 게이트웨이",
  "help.flow.vendor": "AI 회사",
  "help.flow.store": "저장(가림·암호화)",
  "help.scope.title": "내가 볼 수 있는 범위",
  "help.scope.lead": "지금 역할: {role} · 보기 범위 {scopes}",
  "help.scope.bundle": "{bundle}: {value}",
  "help.scope.flow": "남의 글은 사유·다시 로그인 확인·대화 단위 허가(60분)를 거쳐요.",
  "help.glossary": "용어집 열기",
  "help.manual": "사용 설명서는 준비 중이에요",
  "help.coverage": "무엇이 기록되나요",
  "access.step.reason": "사유",
  "access.step.reauth": "다시 로그인 확인",
  "access.step.grant": "허가",
  "access.caseLabel": "승인된 조사 건",
  "access.caseNone": "사유 직접 입력",
  "access.caseHint": "선택한 조사 건의 승인 사유를 사용해요. 재인증은 그대로 필요해요.",
  "access.caseRequired": "여러 사람의 대화를 반복해서 열람하려면 승인된 조사 건이 필요해요.",
  "access.caseManage": "조사·승인으로 이동",
  "access.catLabel": "사유 범주",
  "access.catHint": "평가·근태는 사유 범주에 없어요.",
  "access.reauth.title": "다시 로그인해 확인해 주세요",
  "access.reauth.desc": "확인하면 10분 동안 다시 묻지 않아요. (목업: 아무 글자나 넣으면 돼요)",
  "access.reauth.password": "비밀번호",
  "access.reauth.google": "Google로 다시 로그인",
  "access.reauth.confirm": "확인하고 열기",
  "access.reauth.empty": "비밀번호를 입력해 주세요.",
  "access.denied": "사유가 짧아 열람을 막았어요. 거부도 이력에 남아요.",
  "access.next": "다음",
  "access.watermark": "열람: {role}(사용자 코드 {code}) · {time}",
  "access.leftClock": "남은 시간 {mmss}",
  "access.expired": "허가 시간이 끝났어요. 다시 사유를 남기면 볼 수 있어요.",
  "setup.title": "초기 설정 체크리스트",
  "setup.done": "{n}/{total} 마침",
  "setup.optional": "선택",
  "setup.ceiling": "기록 수준 상한 정하기",
  "setup.notice": "안내문 게시",
  "setup.teams": "팀 만들기·매니저 지정",
  "setup.invite": "사람 초대",
  "setup.connect": "연결 안내 보내기",
  "setup.gateway": "게이트웨이·조직 보고서 연결",
  "footer.noRecord": "기록 없음 ≠ 안 씀",
  "sessionTitle.anon": "대화 #{no} · 질문 {n}개 · {chars}자",
  "common.close": "닫기",
  "common.more": "더 보기",
  "common.undo": "되돌리기",
  "nav.moreCurrent": "지금 보는 화면: {page}",
  "access.catRequired": "사유 범주를 골라 주세요.",
  "level.name.1": "기본 정보",
  "level.name.2": "질문 글",
  "level.name.3": "AI 답변 글",
  "level.name.4": "작업 상세",
  "card.excludedDeletion": "삭제 요청으로 {n}건 제외",
  "url.fix.title": "주소의 조건 일부를 바꿔 열었어요",
  "url.fix.scope": "보기 범위 ‘{want}’{eun} 이 화면에서 볼 수 없어 ‘{got}’{ro} 열었어요.",
  "url.fix.period": "기간 값이 맞지 않아(최대 366일·미래 날짜 불가) ‘{got}’{ro} 열었어요.",
  "url.fix.method": "사용 방식 값이 맞지 않아 ‘전체’로 열었어요.",
  "url.fix.team": "없는 팀이라 ‘모든 팀’으로 열었어요.",
  "url.fix.teamSmall": "주소의 팀은 3명보다 적어 고를 수 없어요(소집단 보호). ‘모든 팀’으로 열었어요.",
  "scope.teamSmallBlocked": "3명보다 적은 팀은 고를 수 없어요(소집단 보호).",
  "support.item.tokens": "사용량(토큰)",
  "reasonShort.consent_before": "동의 전",
  "reasonShort.paused": "일시 중지",
  "reasonShort.level_off": "수준에서 꺼짐",
  "reasonShort.cli_not_sent": "CLI 설정",
  "reasonShort.tool_not_sent": "안 보냄",
  "reasonShort.not_applicable": "해당 없음",
  "reasonShort.version_checking": "확인 중",
  "reasonShort.old_version": "낮은 버전",
  "reasonShort.expired": "보관 지남",
  "reasonShort.gap": "못 받음",
  "reasonShort.permission": "권한 필요",
  "reasonShort.small_group": "3명 미만",
  "reasonShort.verifying": "검증 중",
  "partialShort.truncated": "잘림",
  "partialShort.estimated_link": "추정 연결",
  "partialShort.estimated": "추정",
  "partialShort.unofficial": "비공식",
  "partialShort.verifying": "검증 중",
  "state.failPill": "불러오지 못함",
  "state.failTitle": "기록을 가져오는 중에 문제가 생겼어요",
  "state.more": "자세히",
  "state.errCode": "오류 번호",
  "common.retryNow": "지금 다시 시도",
  "toast.working": "진행 중이에요",
  "toast.close": "알림 닫기",
  "toast.stack": "진행 중인 알림",
  "palette.group.recent": "최근 검색",
  "palette.recent.sub": "이 검색어로 다시 찾기",
  "palette.recent.clear": "최근 검색 모두 지우기",
  "palette.recent.clearSub": "이 브라우저에만 남아 있어요",
  "palette.recent.cleared": "최근 검색을 지웠어요",
  "period.limitHint": "최대 366일까지 고를 수 있어요. 오늘 뒤의 날짜는 고를 수 없어요.",
  "period.sum": "{from}~{to} · {n}일",
  "period.err.empty": "시작일과 종료일을 모두 넣어 주세요.",
  "period.err.future": "오늘({today}) 뒤의 날짜는 고를 수 없어요.",
  "period.err.long": "최대 366일까지 고를 수 있어요(지금 {n}일).",
  "empty.connect.title": "아직 받은 기록이 없어요.",
  "empty.connect.l1": "기록이 없다고 AI를 안 쓴 건 아니에요.",
  "empty.connect.l2": "도구를 연결하면 다음 질문부터 여기에 기록돼요.",
  "empty.connect.btn": "도구 연결하기",
  "bell.newLive": "새 알림이 {n}개 왔어요",
  "chart.avgN": "평균 {v}",
};

export default common;
